// @flow

import React from 'react';
import { rem } from 'polished';
import styled, { type StyledComponent } from 'styled-components';
import {
  fontFamily,
  colors,
  colorPalette,
  sizes,
  timings,
} from '../../../styles/GlobalStyle';

type PushProps = {|
  className?: string,
  url?: string,
  target?: string,
  title: string,
  subtitle: string,
  visual?: string,
|};

const RawPush = ({
  className,
  url = '#',
  target = '_self',
  title,
  subtitle,
  visual = '',
}: PushProps) => {
  return (
    <a className={className} href={url} target={target}>
      <span className="visual-wrapper">
        <img className="visual" src={visual} alt="" />
      </span>
      <span className="content">
        <span className="title">{title}</span>
        <span className="subtitle">{subtitle}</span>
      </span>
    </a>
  );
};

export const Push: StyledComponent<PushProps, {}, typeof RawPush> = styled(
  RawPush
)`
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100px;
  background-color: ${colors.darkGrey};
  border-radius: ${sizes.borderRadius};
  text-decoration: none;
  padding: 30px ${sizes.padding};
  overflow: hidden;
  transition: background-color ${timings.hover};

  .content {
    position: relative;
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
  }

  .title,
  .subtitle {
    display: block;
    transition: color ${timings.hover};
  }

  .title {
    font-family: ${fontFamily.secondary.regular.fontFamily};
    font-size: ${rem(20)};
    color: ${colorPalette.primary.active};
  }

  .subtitle {
    font-family: ${fontFamily.primary.black.fontFamily};
    font-weight: ${fontFamily.primary.black.fontWeight};
    font-size: ${rem(15)};
    color: ${colors.white};
    text-transform: uppercase;
  }

  .visual-wrapper {
    position: absolute;
    display: block;
    width: 544px;
    text-align: center;
    left: calc(60% - 150px);
    top: 50%;
    transform: translateY(calc(-50% + 40px));
  }

  .visual {
    height: 140px;
  }

  &:hover {
    background-color: ${colorPalette.primary.active};

    .title,
    .subtitle {
      color: ${colorPalette.primary.foreGround};
    }
  }
`;
